<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
<!--    <Title :title="route"></Title>-->

    <Setp :nodes="nodes" :audits="audits"></Setp>

    <el-card class="box-card" style="min-height: 650px;margin-top: 15px" shadow="never">
      <el-form label-position="left" label-width="150px">

        <el-divider content-position="left">申请人信息</el-divider>

        <el-form-item label="申请人">
          <el-input v-model="user.realName" readonly></el-input>
        </el-form-item>

        <el-form-item label="所属部门">
          <el-input v-model="user.deptName" readonly></el-input>
        </el-form-item>

        <el-divider content-position="left">文件信息</el-divider>

        <el-form-item label="盖章类型" prop="hasProject">
          <el-radio-group v-model="detail.hasProject" style="cursor: not-allowed;pointer-events:none">
            <el-radio label="1">项目盖章</el-radio>
            <el-radio label="2">文件盖章</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="detail.hasProject ==1" label="项目名称"
                      prop="projectId">
          <el-input v-model="detail.projectName"></el-input>
        </el-form-item>

        <div v-if="detail.hasProject ==2">

          <el-form-item label="文件名称" prop="fileName">
            <el-input v-model="detail.fileName" readonly>
            </el-input>
          </el-form-item>

          <el-form-item label="文件份数" prop="fileName">
            <el-input-number v-model="detail.fileNum" :min="1" :max="100" disabled></el-input-number>
          </el-form-item>
        </div>

        <el-form-item label="用章文件">
          <div v-if="hasFile">
            <el-link type="primary" @click="download()">下载文件</el-link>
            <el-link style="margin-left: 8px" v-if="isPdf(detail.filePath)" type="primary" @click="viewPdf(detail.filePath)">预览</el-link>
          </div>
          <div v-if="!hasFile">
            <el-link type="primary">未上传文件</el-link>
          </div>

        </el-form-item>

        <el-divider content-position="left">用章信息</el-divider>


        <el-form-item label="用章时间" prop="useTime">

          <el-date-picker
              readonly
              v-model="detail.useTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="章子外出" prop="sealOut">
          <el-radio-group v-model="detail.sealOut" style="cursor: not-allowed;pointer-events:none">
            <el-radio label="1">否</el-radio>
            <el-radio label="2">是</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="章子类别" prop="sealTypeArray">
          <el-checkbox-group v-model="detail.sealTypeArray" style="cursor: not-allowed;pointer-events:none">
            <el-checkbox label="1">公章</el-checkbox>
            <el-checkbox label="2">合同章</el-checkbox>
            <el-checkbox label="3">法人章</el-checkbox>
            <el-checkbox label="4">财务章</el-checkbox>
            <el-checkbox label="5">发票章</el-checkbox>
            <el-checkbox label="6">营业执照</el-checkbox>
            <el-checkbox label="7">法人身份证原件</el-checkbox>
            <el-checkbox label="8">法人身份复印件</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="用章事由" prop="reason">
          <el-input type="textarea" rows="5" maxlength="500" show-word-limit readonly
                    v-model="detail.reason"></el-input>
        </el-form-item>

        <AuditList :audits="audits" :auditHistory="auditHistory"></AuditList>


        <div v-if="allowAudit==true">
          <el-divider content-position="left">我要审批</el-divider>


          <el-form-item label="审批意见" prop="remarks">
            <el-input type="textarea" rows="5" maxlength="500" show-word-limit
                      v-model="ruleForm.auditOpinion"></el-input>
          </el-form-item>


          <el-Form-item>
            <el-button type="primary" @click="audit(2)">审核通过</el-button>
            <el-button type="danger" @click="audit(3)">审核拒绝</el-button>
          </el-Form-item>
        </div>

      </el-form>
    </el-card>
    <el-dialog :visible.sync="showPdf" :append-to-body="true" top="0" custom-class="pdf-viewer">
      <div style="width:100%; height:100%;">
        <iframe id="myIframe" :src="pdfurl" width="100%" height="900px"></iframe>
      </div>
    </el-dialog>
  </div>


</template>

<script>
import Title from "../../Title";
import {requestApplyDetail, requestAudit, requestAuditShow} from "../../../api";
import AuditList from "../common/AuditList";
import Setp from "../common/Setp";
import {minioServer, IsPdf} from "../../../util";

export default {
  components: {AuditList, Title, Setp},
  name: "SealDetail",
  props: {
    // 接收父组件传入的参数
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      route: {
        name: '用章申请详情',
        path: ''
      },
      detail: {
        useTime: []
      },
      audits: [],
      auditHistory: [],
      applyId: "",
      applyServiceId: "",
      applyType: "",
      ruleForm: {
        auditOpinion: "",
      },
      nodes: [],
      allowAudit: false,
      user: {},
      hasFile: true,
      showPdf: false,
      pdfurl: ""
    }
  },
  created() {
    // this.route.path = this.$route.fullPath
    this.applyId = this.query.applyId
    this.applyServiceId = this.query.applyServiceId
    this.applyType = this.query.applyType
    this.getObject()
    this.getAuditShow()
  },
  methods: {
    download() {
      window.open(minioServer + this.detail.filePath)
    },
    getAuditShow() {
      requestAuditShow({
        applyId: this.applyId,
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            if (res.object == 1) {
              this.allowAudit = true
            }
            if (res.object == 2) {
              this.allowAudit = false
            }
          }
        }
      })
    },
    audit(isAgree) {

      this.allowAudit = false

      if (isAgree == 2 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "同意"
      }
      if (isAgree == 3 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "不同意"
      }

      requestAudit({
        isAgree: isAgree,
        applyId: this.applyId,
        applyType: this.applyType,
        auditOpinion: this.ruleForm.auditOpinion,
      }).then(res => {
        if (res.code == 200) {
          this.getAuditShow()
          this.getObject()
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.detail = res.object.detail
            if (this.detail.hasProject) {
              this.detail.hasProject = this.detail.hasProject + ''
            }
            if (this.detail.sealOut) {
              this.detail.sealOut = this.detail.sealOut + ''
            }
            if (res.object.detail.sealType) {
              let sealTypeArray = res.object.detail.sealType.split(",")
              this.detail.sealTypeArray = sealTypeArray
              /*let newArray = []
              sealTypeArray.forEach((item,index,arr)=>{
                newArray.push(item+'')
              })
              this.detail = */

            }
            if (res.object.detail.beginTime && res.object.detail.endTime) {
              this.$set(this.detail, "useTime", [
                "" + res.object.detail.beginTime + "",
                "" + res.object.detail.endTime + "",
              ]);
            }
            this.user = res.object.user
            this.audits = res.object.audits
            this.auditHistory = res.object.auditHistory
            this.nodes = res.object.nodes
            if (!this.detail.filePath) {
              this.hasFile = false
            }
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    viewPdf(path) {
      this.showPdf = true
      this.pdfurl = "/pdfjs/web/viewer.html?file=" + minioServer + path
    },
    isPdf(fileName) {
      return IsPdf(fileName)
    }
  }
}
</script>

<style scoped>

</style>




